import { format } from "date-fns";
import React from "react";

export const DropdownArrowMarker: React.FC<{
    value: any;
    isEditable: boolean;
    forceDateFormat?: boolean;
}> = ({ value, isEditable, forceDateFormat = false }) => {
    let display = "";

    if(value) {
        const stringVal = String(value).trim();

        const normalize = stringVal.replace(/_/g,"-");
        if(forceDateFormat || (/^\d{4}-\d{2}-\d{2}$/.test(normalize) )){
            try {
                display = format(new Date(normalize), "yyyy-MM-dd");
            } catch {
                display = stringVal;
            }
        } else {
            display = stringVal;
        }
    }

    //     if(/^\d{4}_\d{2}_\d{2}$/.test(stringVal)){
    //         display = stringVal;
    //     } else if (/^\d{4}-\d{2}-\d{2}$/.test(stringVal)) {
    //         try {
    //             const date = new Date(stringVal);
    //             if(isValid(date)) {
    //                 display = format(date, "yyyy-MM-dd");
    //             } else {
    //                 display = stringVal;
    //             }
    //         } catch {
    //             display = stringVal;
    //         }
    //     }else if (/^\d{4}$/.test(stringVal)) {
    //         display = stringVal;

    //     }else {
    //         display = stringVal;
    //     }
    // }


    return (
        <div style={{
            display: 'flex', justifyContent: "space-between", alignItems: 'center', paddingRight: 8 
        }}>
            <span>{display}</span>
            {isEditable && (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="25"
                    height="25"
                    fill="gray"
                    >
                        <path d="M7 10l5 5 5-5z" />
                    </svg>
            )}
        </div>
    );
};